











import { Vue, Component, Prop } from 'vue-property-decorator'
import { Skill } from '@/static/ts/skill'

@Component
export default class SkillHeader extends Vue {
  @Prop() private skill!: Skill
  private lv (lv: number) {
    return 'LV ' + lv / 10 + ' / 10'
  }
}
